import accept from '../assets/accept.wav'
import deny from '../assets/deny.wav'


const acceptAudio = new Audio(accept);
const denyAudio = new Audio(deny);



export const AudioPlay = {

    playAcceptAudio: () => {
        acceptAudio.play();
    },
    playDenyAudio: () => {
        denyAudio.play();
    },
};